import React, { useEffect } from  'react';
import arrowDown from '../../../img/arrowDOWN.svg';
import RegisterForm from '../RegisterForm/RegisterForm';
import Contact from '../Contact/Contact';
import './RegisterPage.scss';
import registerImg from '../../../img/register.svg';
import { Helmet } from 'react-helmet-async';

export default function RegisterPage() { 
    useEffect(()=> {
        window.scrollTo({ top: 0 });
    }, []);

    return(
        <section className='registerPage'>
            <Helmet>
                <title>Załóż konto | Nekrodruk.pl</title>
                <meta name="robots" content="noindex" />
            </Helmet>
            <div className='registerPage_wrapper'>
                <div className='registerImgWrapper'>
                    <img src={registerImg} alt="" className='registerImg' />
                </div>
                <div className='registerPage_form'>
                    <RegisterForm />
                </div>

            </div>
            <div className='registerPage_info'>
                <img src={arrowDown} alt="" className='registerPage_arrowDown'/>
                <p>Wystąpił problem, a może chcesz dowiedzieć się więcej na temat aplikacji?</p>
                <img src={arrowDown} alt="" className='registerPage_arrowDown'/>
            </div>
            <Contact />
        </section>
    )
   
}